define('views/transfer/transfer',[
	'views/_base/baseview',
	'text!views/transfer/transfer.html',
	'views/transfer/friends-and-family',
	'models/accounts/bank',
	'views/shared/button/button',
	'views/shared/modal/modal_modern',
	'views/transfer/transfer_from_option',
	'views/transfer/transfer_to_option',
], function (
	BaseView,
	Template,
	FriendsAndFamily,
	BankModel,
	ButtonComponent,
	Modal,
	TransferFromOptionView,
	TransferToOptionView
) {
	'use strict';

	return BaseView.extend({
		id: 'transfer-container',
		tagName: 'div',
		isRender: false,
		template: _.template(Template),
		events: {
			'click .transfer-from-option': 'updateFromSelectList',

			'click .select-wrapper': 'showSelectOptions',
			'click .js-transfer-memo-btn': 'showMemo',
			'click .transfer-friends-family-search': 'enableSearch',

			'blur #amount': 'handleAmountBlur',
			'keyup #amount': 'handleAmountInputKeyup',
			'keyup .js-transfer-memo-note': 'charCount',
			'keydown .js-transfer-memo-note': 'charCount',
			'mouseout .js-transfer-memo-note': 'charCount',
		},
		initialize: function (options) {
			options = options || {};

			this.elementName = options.elementName;

			this.cip_status = checkCipStatus();

			this.all_data_loaded = false;
			this.bank_loaded = false;
			this.rules_loaded = false;
			this.accounts_loaded = false;

			this.transfer = {};
			this.transfer_ruleset = null;

			this.is_valid = false;
			this.isConfirmed = 0;
			this.spending_account = {};
			this.savings = {};
			this.transfer_rules = null;
			this.successful_transfer = false;
			this.formValid = false;
			this.amount = null;
			this.bank_account = null;

			BaseView.prototype.initialize(this);
		},

		render: function () {
			var that = this,
				data = {
					spending_account: this.spending_account,
					savings_accounts: this.savings,
					bank_account: this.bank_account,
				};

			this.$el.html(this.template({ data: data }));

			this.sendButton = this.$('#send-transfer');
			this.cancelLink = this.$('.js-transfer-cancel');
			this.messageContainer = this.$('.message-container');

			$(document).on('click', _.bind(this.closeDropdowns, this));

			this.addTransferButton();

			return this;
		},

		loadData: function () {
			var that = this;

			if (this.cip_status && pf.IsConsumerFinancial) {
				checkFinRegStatus(function (resp) {
					pf.controller.loadAccounts(function () {
						that.getBankAccount();
						that.loadRules();
						that.loadSelects();

						that.startDataCheck();
					});
				});
			} else {
				goToFinancialRegistration('transfer');
			}
		},

		startDataCheck: function () {
			if (this.all_data_loaded) {
				this.render();

				this.addFromSelect();
			} else {
				this.dataCheckPoints();
			}
		},

		dataCheckPoints: function () {
			var that = this,
				not_finished = false;

			if (!this.bank_loaded) {
				not_finished = true;
			}

			if (!this.rules_loaded) {
				not_finished = true;
			}

			if (!this.accounts_loaded) {
				not_finished = true;
			}

			if (!not_finished) {
				this.all_data_loaded = true;
			}

			setTimeout(function () {
				that.startDataCheck();
			}, 1000);
		},

		getBankAccount: function () {
			var that = this;

			this.bank = new BankModel();
			this.bank.fetch({
				success: function (model, resp) {
					var data = that.bank.toJSON();

					if (data) {
						that.bank_loaded = true;
						that.bank_account = data;
					}
				},
				error: function (err, a) {
					// console.log('getBankAccount error', err, a);
					// TODO: Show error state
				},
			});
		},

		loadRules: function () {
			var that = this;

			$.ajax({
				type: 'GET',
				url: pf.url + '/Transfers/Rules',
			})
				.done(function (response) {
					that.transfer_rules = response;
					that.rules_loaded = true;
				})
				.fail(function (err) {
					// console.error('error loading transfer rules', err);
				});
		},

		loadSelects: function () {
			this.savings = pf.accounts.savings;
			this.spending_account = pf.accounts.spending_account;

			if (this.savings && this.spending_account) {
				this.accounts_loaded = true;
			}
		},

		addFromSelect: function () {
			var that = this;

			pf.accounts.data.forEach(function (account) {
				var account_option_view = new TransferFromOptionView({
					account: account,
					parent_view: that,
				});

				that.$('.js-select-from-list').append(account_option_view.el);
			});
		},

		updateFromSelectList: function (e) {
			if (e && e.preventDefault) {
				e.preventDefault();
			}
			if (e && e.stopPropagation) {
				e.stopPropagation();
			}

			var account = $(e.target),
				account_name = account.find('a').text(),
				account_id = account.data('account-id'),
				entity_id = account.data('entity-id');

			// Update Transfer object
			this.transfer.from = {
				account_id: account_id,
				entity_type_id: entity_id,
			};

			// Hide placeholder
			this.$('.js-transfer-from-placeholder').hide();

			// Update and show the From Select visual display
			this.$('.js-transfer-from-display').html(account_name).show();

			// Hide From list
			account.parent().removeClass('showing');

			// Remove any error classes
			account.parent().parent().removeClass('has-error');

			// Load Transfer To list
			this.updateToSelectList();
		},

		updateToSelectList: function () {
			var that = this;

			// Empty To select list
			this.$('.js-transfer-to-list').empty();

			// Empty the display from previous searches
			this.$('.js-transfer-to-display').empty();

			// Ensure the placeholder is shown
			this.$('.js-transfer-to-placeholder').removeClass('hidden');

			// Find To rule set from the From selection
			this.transfer_rules.forEach(function (rule_set) {
				if (that.transfer.from.entity_type_id == rule_set.from_entity_type_id) {
					that.transfer_ruleset = rule_set.to_entity_type_ids;
				}
			});

			// Enact the rule set to show proper options
			this.transfer_ruleset.forEach(function (rule) {
				var is_consumer = false;

				// Check to see if Consumer (AKA - friends or family)
				if (rule.to_entity_type_id == enums.entityTypeEnum.Consumer) {
					var account = null;
					is_consumer = true;
				}

				// Check to see if Bank Account
				if (rule.to_entity_type_id == enums.entityTypeEnum.ExternalBank) {
					if (that.bank_account.verification_status == 2) {
						var account = that.bank_account;
					} else {
						return false;
					}
				}

				// Check to see if a spending account
				if (rule.to_entity_type_id == enums.entityTypeEnum.SpendingAccount) {
					var account = that.spending_account;
				}

				// Lastly check to see if an account or else append the found account
				if (rule.to_entity_type_id == enums.entityTypeEnum.Account) {
					pf.accounts.savings.forEach(function (account) {
						var account_option_view = new TransferToOptionView({
							rule: rule,
							account: account,
							parent_view: that,
						});

						that.$('.js-transfer-to-list').append(account_option_view.el);
					});
				} else if (!_.isEmpty(account)) {
					var account_option_view = new TransferToOptionView({
						rule: rule,
						account: account,
						parent_view: that,
					});

					that.$('.js-transfer-to-list').append(account_option_view.el);
				}
			});

			// Enable the To select element
			this.$('.js-transfer-to').removeClass('disabled');
		},

		handleTransferToSelection: function (name) {
			$('.js-transfer-to-display').text(name);
			$('.js-transfer-to-placeholder').addClass('hidden');
			$('.js-transfer-to-list').removeClass('showing');
			$('.js-transfer-to').removeClass('has-error');
		},

		addTransferButton: function () {
			this.transfer_button = new ButtonComponent({
				// General
				elementName: '.js-transfer-button-container',
				calling_view: this,
				// Transactional
				is_transaction: false,
				transaction_callback: this.invalidTransaction,
				// Default
				btn_label: pf.getContent('transfer.content.button_component.label'),
				btn_callback: this.validateTransfer,
				btn_retry_callback: this.validateTransfer,
				// Confirm
				btn_confirm: true,
				btn_confirm_amount: 0,
				btn_confirm_label: pf.getContent(
					'transfer.content.button_component.confirm_label'
				),
				btn_confirm_callback: this.transferFunds,
				// Cancel
				btn_cancel: false,
				btn_cancel_label: pf.getContent(
					'transfer.content.button_component.cancel_label'
				),
				btn_cancel_callback: this.cancelTransfer,
				// Success
				btn_success: true,
				btn_success_delay: 700,
				btn_success_label: pf.getContent(
					'transfer.content.button_component.success_label'
				),
				btn_success_message: pf.getContent(
					'transfer.content.button_component.success_message'
				),
				btn_success_callback: this.transferSuccess,
				// Error
				btn_error: true,
				btn_error_delay: 700,
				btn_error_label: pf.getContent(
					'transfer.content.button_component.error_label'
				),
				btn_error_cancel_label: pf.getContent(
					'transfer.content.button_component.cancel_label'
				),
				btn_error_message: pf.getContent(
					'transfer.content.button_component.error_message'
				),
				btn_error_callback: this.canceledOnError,
			});
		},

		cancelTransfer: function (that) {
			var that = that ? that : this;

			that.resetTransfers();
		},

		invalidTransaction: function () {},

		transferSuccess: function (resetButtons, that) {
			var that = that ? that : this;

			if (resetButtons.name) {
				that.transfer_button[resetButtons.name]();
			} else {
				resetButtons(that.transfer_button);
			}

			setTimeout(function () {
				that.resetTransfers();
			}, 700);
		},

		canceledOnError: function (that) {
			var that = that ? that : this;
			// that.transfer_button[err.name]();

			if (_.isFunction(this.resetTransfers)) {
				this.resetTransfers();
			} else if (_.isFunction(that.resetTransfers)) {
				that.resetTransfers();
			}
		},

		validateTransfer: function (proceedToConfirm, that) {
			var that = that ? that : this;

			checkFinRegStatus(function (resp) {
				that.is_valid = true;

				if (
					_.isEmpty(that.$('.js-transfer-from .js-selected').text()) ||
					!that.accountHasMoney()
				) {
					that.is_valid = false;
					that.showError(
						that.$('.js-transfer-from .js-selected').parents('.select-wrapper')
					);
					return;
				}

				if (
					_.isEmpty(that.$('.js-transfer-to .js-selected').text()) &&
					!that.$('.js-transfer-to').hasClass('disabled')
				) {
					that.is_valid = false;
					that.showError(
						that.$('.js-transfer-to .js-selected').parents('.select-wrapper')
					);
					return;
				}

				if (isNaN(that.amount) || that.amount <= 0 || that.amount <= '0') {
					that.is_valid = false;
					that.showError(
						that.$('#amount'),
						sysText['FV']['invalid']['amountInvalid']
					);
					return;
				}

				if (that.is_valid) {
					if (proceedToConfirm.name) {
						that.transfer_button[proceedToConfirm.name]();
					} else {
						proceedToConfirm(that.transfer_button);
					}
				}
			});
		},

		accountHasMoney: function () {
			var that = this,
				has_money = false;

			if (this.transfer.from) {
				if (
					this.transfer.from.entity_type_id ==
					enums.entityTypeEnum.SpendingAccount
				) {
					// If it is a spending account, then ensure the balance is greater than the transfer amount
					var spending_account = pf.accounts.data.filter(function (account) {
						return (
							account.entity_type_id == enums.entityTypeEnum.SpendingAccount
						);
					})[0];

					if (spending_account && spending_account.balance >= that.amount) {
						has_money = true;
					}
				} else if (
					this.transfer.from.entity_type_id == enums.entityTypeEnum.ExternalBank
				) {
					// If it is a bank account we skip the funds check
					has_money = true;
				} else {
					pf.accounts.data.forEach(function (account) {
						if (
							account.account_id == that.transfer.from.account_id &&
							account.balance > 0 &&
							account.balance >= that.amount
						) {
							has_money = true;
						}
					});
				}
			} else {
				has_money = false;
			}

			return has_money;
		},

		transferFunds: function (processComplete, that) {
			var that = that ? that : this;

			if (that.is_valid) {
				var data = {
					to: that.transfer.to,
					from: that.transfer.from,
					memo: that.$('#memo').val(),
					amount: that.amount,
				};

				$.ajax({
					url: pf.url + '/transfers',
					data: JSON.stringify(data),
					type: 'POST',
					contentType: 'application/json',
					success: function (response) {
						var success_message = '';

						if (that.transfer.from.entity_type_id == 9) {
							success_message = 'Your funds request has been submitted';
						} else {
							success_message = 'Transfer successfully sent';
						}

						that.transfer_button.updateSuccessMessage(success_message);

						if (processComplete.name) {
							that.transfer_button[processComplete.name](true);
						} else {
							processComplete(true, that.transfer_button);
						}
					},
					error: function (err) {
						if (processComplete.name) {
							that.transfer_button[processComplete.name](false);
						} else {
							processComplete(false, that.transfer_button);
						}
					},
				});
			} else {
				if (processComplete.name) {
					that.transfer_button[processComplete.name](false);
				} else {
					processComplete(false, that.transfer_button);
				}
			}
		},

		showMemo: function (e) {
			e.preventDefault();

			$(e.currentTarget).addClass('hidden');
			this.$('.transfer-memo-note-parent').addClass('open');
		},

		charCount: function (e) {
			var textarea = $(e.target),
				textareaValueLength = textarea.val().length,
				$target = this.$('#update'),
				maxLength = pf.getContent(
					'transfer.content.transfer_form.memo.character_count'
				);

			if (textareaValueLength > maxLength) {
				textarea.val(textarea.val().substring(0, maxLength));
				textareaValueLength = maxLength;
			}

			$target.text(maxLength - textareaValueLength);
		},

		showFriendsAndFamily: function () {
			var find_friends_view = new FriendsAndFamily({
					UGID: pf.session.get('UserGUID'),
					parentView: this,
				}),
				modal = new Modal({
					show: true,
					content: find_friends_view.$el.html(),
					calling_view: find_friends_view,
				});
		},

		showSelectOptions: function (e) {
			var selectEl = $(e.currentTarget).find('ul'),
				allSelects = this.$('.select-wrapper-options-list'),
				wrapper = selectEl.parent();

			// remove any open select boxes
			allSelects.removeClass('showing');

			if (!wrapper.hasClass('disabled')) {
				selectEl.toggleClass('showing');
			}
		},

		showError: function (el, message) {
			el.addClass('has-error');

			if (message) {
				el.next('.error-message').removeClass('hidden').text(message);
			}
		},

		resetTransfers: function (e) {
			if (e) {
				e.preventDefault();
			}

			// this.render();
			this.loadData();
		},

		handleAmountInputKeyup: function (e) {
			var data = keyupCurrencyHandling(e);

			$(e.target).val(data.string);

			this.amount = Number(data.number);

			this.transfer_button.updateCofirmAmount(this.amount);
		},

		handleAmountBlur: function (e) {
			var data = blurCurrencyHandling(e);

			$(e.target).val(data.string);

			this.amount = Number(data.number);

			this.transfer_button.updateCofirmAmount(this.amount);

			$(e.target).removeClass('has-error');
			$(e.target).next().addClass('hidden');
		},

		closeDropdowns: function (e) {
			if (
				!$(e.target).hasClass('select-option') &&
				!$(e.target).hasClass('select-wrapper') &&
				!$(e.target).hasClass('select-wrapper-header')
			) {
				this.$('.select-wrapper > ul').removeClass('showing');
			}
		},

		close: function () {
			$(document).off('click', _.bind(this.closeDropdowns, this));
		},
	});
});

